import { render } from "./PersonIcon.vue?vue&type=template&id=597919b1"
import script from "./PersonIcon.vue?vue&type=script&lang=js"
export * from "./PersonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__